import Chart from 'chart.js'
import annotations from 'chartjs-plugin-annotation'
import scalesDefault from 'constants/chart'


/* this is a set up of chat js */
Chart.Tooltip.positioners.cursor = (chartElements, coordinates) => coordinates
Chart.defaults.global.scales = {
  ...scalesDefault,
}
Chart.defaults.global.tooltips = {
  ...Chart.defaults.global.tooltips,
  position: 'cursor',
  mode: 'index',
  intersect: false,
}
Chart.defaults.global.tooltips.mode = 'index'
Chart.defaults.global.tooltips.position = 'cursor'
Chart.defaults.global.tooltips.intersect = false

Chart.plugins.register({
  annotations,
})

export default Chart
